<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
        <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
            <span class="ti-save"></span>Сохранить
        </button>
      </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "warehouse/features",
    cardSetLink: "warehouse/features",
    item: null,
    fields: [
      {
        label: "Название",
        key: "title",
        type: "field",
        textType: "text", 
        isMultiLang:true
      },
            {
                col:' col-12',
                key: "name",
                label: "Класс",
                type: "select",
                modal:'name',
                selectKey: "title",
                textType: "text",
              },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
